import { Button, ButtonProps } from "@newsela/angelou";
import AiSparkIconSVG from "@/icons/AiSparkIcon/AiSparkIconSVG";
import { buttonCss, removeIconCss } from "./AiButton.style";

export type AIButtonProps = Partial<ButtonProps> & {
  /**
   * If true, the icon will be omitted
   */
  removeIcon?: boolean;
  alignment?: "left" | "right";
};

export const AIButton = (props: AIButtonProps) => {
  const {
    children = "Loading AI Content",
    removeIcon = false,
    __cssFor = {},
  } = props;
  return (
    <Button
      {...props}
      icon={{
        SvgComponent: AiSparkIconSVG,
        alignment: props.alignment || Button.iconAlignments.right,
        ...props.icon,
      }}
      __cssFor={{
        root: [buttonCss, __cssFor?.root],
        ...(removeIcon && { Icon: removeIconCss }),
      }}
    >
      {children}
    </Button>
  );
};

AIButton.displayName = "AIButton";

export default AIButton;
